export default __webpack_public_path__ + "static/media/buy.a58def48.svg";